import axios from "axios";
import { showError } from "../utils/toast";
import { store } from "../app/store";
import { setMultipleSessionActive, setAccountBlocked } from "../features/auth/authSlice";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

// ✅ Request interceptor (attach token)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor (GLOBAL error handling)
apiClient.interceptors.response.use(
  (response) => {
    // Globally unwrap { success: true, data: ... } responses
    if (response.data && typeof response.data === 'object' && response.data.success !== undefined && response.data.data !== undefined) {
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong";

    // 🔒 Auth errors
    if (status === 401) {
      const state = store.getState();
      const isMultipleSessionActive = state.auth?.isMultipleSession === true;

      if (message === "Your account has been blocked") {
        store.dispatch(setAccountBlocked(true));
      } else if (!isMultipleSessionActive) {
        showError("Session expired. Please login again.");
        store.dispatch(setMultipleSessionActive());
      }
    }

    // 🚫 Forbidden
    else if (status === 403) {
      showError("You are not allowed to perform this action.");
    }

    // 🔥 Server errors
    else if (status >= 500) {
      showError("Server error. Please try again later.");
    }

    // ⚠️ Default
    else {
      showError(message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;